import type { SidekickChipConfig } from '../components/SidekickSuggestionsCard';

/**
 * Suggestion chips requested from the memory service. Matches the
 * three-chip column in the expanded dock design.
 */
export const DOCK_SUGGESTIONS_LIMIT = 3;

/**
 * Chips shown when the memory service returns nothing usable.
 *
 * Their copy lives in the package's own namespace rather than a
 * consumer's, because the fallback has to read correctly in any host
 * — including one whose suggestion namespace has no Sidekick keys at
 * all.
 */
export const DOCK_FALLBACK_CHIPS: ReadonlyArray<SidekickChipConfig> = [
  {
    id: 'fallback-idle-last-week',
    translationKey: 'dock.suggestions.idleLastWeek',
  },
  {
    id: 'fallback-utilization-last-month',
    translationKey: 'dock.suggestions.utilizationLastMonth',
  },
  {
    id: 'fallback-idling-time-this-week',
    translationKey: 'dock.suggestions.idlingTimeThisWeek',
  },
];
